import * as React from "react"
import { cn } from "@/lib/utils"

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical"
  decorative?: boolean
}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
    <div
      ref={ref}
      role={decorative ? "none" : "separator"}
      aria-orientation={orientation}
      className={cn(
        "shrink-0 bg-gradient-to-r from-transparent via-[var(--color-border)] to-transparent",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px] bg-gradient-to-b",
        className
      )}
      {...props}
    />
  )
)
Separator.displayName = "Separator"

export { Separator }